import { Injectable } from '@angular/core';
import { StoreBase } from '@stores/abstract';
import { BudgetEstimator } from '@stores/models';

@Injectable({ providedIn: 'root' })
export class BudgetEstimatorStore extends StoreBase<BudgetEstimator> {
  override storeName = 'BudgetEstimatorStore';
}
